import { Colorscheme, Hovercolorscheme, StoryblokColorToColorscheme } from "src/_theme/colorscheme";


export class CmsStory {
    constructor(
        public name: string,
        public created_at: any,
        public published_ad: any,
        public updated_at: any,
        public id: number,
        public uuid: string,
        public content: Content,
        public slug: string,
        public full_slug: string,
        public sort_by_date: any,
        public position: number,
        public tag_list: any[],
        public is_startpage: boolean,
        public parent_id: number,
        public meta_data: any,
        public group_id: string,
        public first_published_at: any,
        public release_id: any,
        public lang: string,
        public path: any,
        public alternates: any[],
        public default_full_slug: string,
        public translated_slugs: string,
    ) { }
}

export class CmsAccordeon {
    constructor(
        public _uid: string,
        public _editable: any,
        public title: string,
        public hidden: boolean,
        public bg_color: string,
        public blocks: CmsAccordeonItem[]

    ) {

    }
}
export class CmsAccordeonItem {
    constructor(
        public _uid: string,
        public _editable: any,
        public title: string,
        public hidden: boolean,
        public accordeon_content: any
    ) {

    }
}


export class Bar {

    constructor(
        public hidden: boolean,
        public bgcolor: string,
        public text_color: string,
        public sticky: boolean,
        public fullwidth: boolean,
        public body: any,
        public audience: StoryblokAudience,
        public show_from_minutes_from_first_visit: number,
        public show_to_minuts_from_first_visit: number

    ) { }
}

export class FeedbackWidget {
    constructor(
        public widget_type: widget_type | string,
        public bgcolor: string,
    ) { }
}
export enum widget_type {
    SIDE = 'side',
    BLOCK = 'block',
    BAR = 'bar'
}


export class CmsTellAFriend {
    color: Colorscheme;
    
    constructor(
        public bgcolor: string,
    ) {
        this.setColorscheme(bgcolor)
    }

    setColorscheme(value: StoryblokColorToColorscheme | string) {
        if (!value) return;

        const scheme = StoryblokColorToColorscheme[value]
        this.color = Colorscheme[scheme]
    }
}

export class CmsImageAsset {
    constructor(
        public id: number,
        public alt: string,
        public name: string,
        public focus: string,
        public title: string,
        public source: string,
        public filename: string,
        public copyright: string,
        public fieldtype: string,
        public is_external_url: boolean
    ) { }
}

export class Button {

    color: Colorscheme
    hovercolor: Hovercolorscheme

    constructor(
        public _uid: string,
        public _editable: any,
        public title: any,
        public hidden: boolean,
        public subtitle: any,
        public type: ButtonType,
        public colorname: string,
        public URL: CmsUrl
    ) {

        this.setColorscheme(colorname)
    }

    setColorscheme(value: StoryblokColorToColorscheme | string) {
        if (!value) return;
        if (this.type === ButtonType.PLAIN) {
            this.color = Colorscheme.transparent;
            this.hovercolor = Hovercolorscheme.transparent;
            return;
        }

        const scheme = StoryblokColorToColorscheme[value]
        this.color = Colorscheme[scheme]
        this.hovercolor = Hovercolorscheme[scheme]
    }
}

export enum ButtonType {
    PLAIN = 'PLAIN',
    SMALL = 'SMALL',
    BIG = 'BIG',
    BIG_DARKGREEN = 'BIG_DARKGREEN',
    ORANGE = 'ORANGE'
}


export class CmsEmbed {
    constructor(
        public title: string,
        public hidden: boolean,
        public embed_url: string,
        public embed_class: string,
    ) { }
}

export class CmsUrl {
    constructor(
        public id: string,
        public url: string,
        public linktype: string,
        public target: string,
        public fieldtype: string,
        public anchor: string,
        public cached_url: string
    ) { }
}
export class CMSLink {
    constructor(
        public id: number,
        public uuid: string,
        public slug: string,
        public path: string,
        public parent_id: string,
        public name: string,
        public is_folder: boolean,
        public published: boolean,
        public is_startpage: boolean,
        public position: number,
        public real_path: string,
        public default_full_slug: string,
        public full_slug: string,
        public alternates: CMSLinkAlternate[]
    ) {
    }
}
export class CMSLinkAlternate {
    constructor(
        public path: string,
        public name: string,
        public lang: string,
        public published: boolean
    ) { }
}

export class Popup {
    constructor(
        public _uid: string,
        public _editable: any,
        public hidden: boolean,
        public title: any,
        public size: ModalSize,
        public bgcolor: string,
        public sections: Section[],
        public closeconfig: PopupCloseConfig,
        public audience: StoryblokAudience,
        public showconfig: PopupShowConfig,
        public showaftertime: number
    ) { }
}
export enum PopupCloseConfig {
    ALL = "ALL",
    CLOSEBUTTON = "CLOSEBUTTON",
    DISMISSABLE = "DISMISSABLE"
}
export enum PopupShowConfig {
    MOUSELEAVE_AND_IDLETIMER = "MOUSELEAVE_AND_IDLETIMER",
    TIMER = "TIMER",
    IMMEDIATELY = "IMMEDIATELY",
    SCROLLUP = "SCROLLUP"
}
export enum StoryblokAudience {
    EVERYONE = "EVERYONE",
    CUSTOMERS = "CUSTOMERS",
    NON_CUSTOMERS = "NON_CUSTOMERS"
}



export enum ModalSize {
    SMALL = "sm",
    MEDIUM = "md",
    LARGE = "lg",
    EXTRALARGE = "xl"
}

export class Content {
    constructor(
        public _uid: string,
        public _editable: any,
        public sections: Section[] | Popup[] | Bar[] | CmsGlobalReference[] | any[],
        public component: string,

    ) { }
}

export class Section {
    constructor(
        public _uid: string,
        public _editable: string,
        public component: string,
        public body: any,
        public cols: string, // is numeric string
        public title: any,
        public hidden: boolean,
        public subtitle: string,
        public width: string,
        public layout: string,
        public bgcolor: string,
        public rounded: boolean,
        public blocks: any[],
        public anchor: string,
        public sticker: any,
        public sticker_bottom: any,
        public condensed: boolean,
        public main_image: any,
        public main_image_bgcolor: string,
        public main_image_contain: boolean,
        public imagereplacement_blocks: any[],
        public reference: string[]
    ) { }
}



export class Slider {
    constructor(
        public caption: string,
        public hidden: boolean,
        public expand_on_desktop: boolean,
        public fixed: boolean,
        public navigation_type: string,
        public slide_type: string,
        public no_of_slides: string,
        public show_numbers: boolean,
        public title: any,
        public slides: Slide[],
        public image_height: number,
        public light_arrows: boolean,
        public auto_slides_per_view: boolean,
        public image_no_resize: boolean

    ) { }
}
export class Slide {
    constructor(
        public bg_color: string,
        public text_color: string,
        public hidden: boolean,
        public blocks: any[],
        public hide_number: boolean,
        public main_image: any,
        public main_image_as_background: boolean,
        public title: any
    ) {
    }
}

export class Card {
    constructor(
        public body: any,
        public title: any,
        public hidden: boolean,
        public video: any,
        public vimeo_video: any,
        public blocks: any[],
        public layout: string,
        public flip_layout: boolean,
        public bgcolor: string,
        public sticker: any,
        public main_image: any,
        public text_color: string,
        public jumpy_image: boolean,
        public image_bgcolor: string,
        public auto_play_video: boolean,
        public main_imagecontain: boolean,
        public new_design: boolean
    ) { }
}

export class Stack {
    constructor(
        public layout: string,
        public hidden: boolean,
        public flip_layout: boolean,
        public bgcolor: string,
        public single_block: any[],
        public stack_blocks: any[]
    ) { }
}

export class CmsSticker {

    color: Colorscheme

    constructor(
        public title: string,
        public hidden: boolean,
        public bg_color: string,
        public position: string,
        public main_image: any,
    ) {
        this.setColorscheme(bg_color)
    }

    setColorscheme(value: StoryblokColorToColorscheme | string) {
        if (!value) return;

        const scheme = StoryblokColorToColorscheme[value]
        this.color = Colorscheme[scheme]
    }
}

export class Imageonly {
    constructor(
        public main_image: any,
        public hidden: boolean,
        public title: any,
        public subtitle: any,
        public CTA: any[]
    ) { }
}

export class CmsGlobalReference {
    constructor(
        public reference: CmsStory[]
    ) { }
}

export class CmsWeekFavorites{

    constructor(
        public Title: any,
        public Description: string,
        public CTA: any[],
        public Link: any,
        public LinkName: string
    ){

    }
}
